import React from 'react';
import Reflux from 'reflux';
import HeaderBuscador from '../sections/HeaderBuscador';
import Footer from '../sections/Footer';
import DocumentMeta from 'react-document-meta';
import NowTops from '../sections/NowTops';
import ReactTooltip from 'react-tooltip';

class HomePage extends Reflux.Component {
    componentDidMount () {
        var scrollpos = window.scrollY;
        var arrowTop = document.getElementById('arrowTop');
        function addClassScroll () {
            arrowTop.classList.add('showArrow');
        }
        function removeAddClassScroll () {
            arrowTop.classList.remove('showArrow');
        }
        window.addEventListener('scroll', function () {
            scrollpos = window.scrollY;
            if (scrollpos >= 30) {
                addClassScroll();
            } else {
                removeAddClassScroll();
            }
        });
    }
    goUpLinear () {
        var scrollDuration = 400;
        var scrollStep = -window.scrollY / (scrollDuration / 15);
        var scrollInterval = setInterval(function () {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else clearInterval(scrollInterval);
        }, 15);
    }
    render () {
        const meta = {
            title: 'Top5.global',
            description: 'Crea tu tops',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                },
                property: {
                    'og:url': process.env.REACT_APP_PUBLIC_URL,
                    'og:title': 'top5.global',
                    'og:description': 'Crea tu tops',
                    'og:image': process.env.REACT_APP_PUBLIC_URL + '/images/top5-global.jpg',
                    'fb:app_id': process.env.REACT_APP_FB_APP_ID,
                    'twitter:site': '@top5globalnow',
                    'twitter:card': 'summary'
                }
            }
        };
        return <div>
          <a className='gravaBrand' href='https://grava.digital' target='_blank' data-tip='Grava.digital' data-for='gravaBrand' />
          <ReactTooltip place='left' type='dark' effect='solid' id='gravaBrand' />
          <DocumentMeta {...meta} />
          <HeaderBuscador />
          <main>
            <NowTops page={Number(this.props.page) || 1} />
          </main>
          <div id='arrowTop' onClick={this.goUpLinear} className='arrowTop'><i className='fa fa-angle-double-up' aria-hidden='true' /></div>
          <Footer />
        </div>;
    }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.js